import * as Ramda from 'ramda';

/**
 * Remove undefined and empty object properties
 *
 * @param  {Object} paramObject An object that will be paramed into a search string
 * @return {Object}             The same object, with all undefined values and empty objects removed.
 */
export function stripUndefinedProperties(paramObject: any) {
    const strippedParams: Record<string, any> = {};
    // @ts-expect-error
    function accumDefined(value, key) {
        if (typeof value === 'object' && !Array.isArray(value)) {
            const strippedParam = stripUndefinedProperties(value);
            if (Object.keys(strippedParam).length !== 0) {
                strippedParams[key] = stripUndefinedProperties(value);
            }
        } else if (typeof value !== 'undefined' && value !== '') {
            strippedParams[key] = value;
        }
    }
    Ramda.forEachObjIndexed(accumDefined, paramObject);

    return strippedParams;
}
